import { render, staticRenderFns } from "./IndexSubVip.vue?vue&type=template&id=638d088d&scoped=true&"
import script from "./IndexSubVip.vue?vue&type=script&lang=js&"
export * from "./IndexSubVip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638d088d",
  null
  
)

export default component.exports